import { colors, dealThemePalette } from '@guryou/colors';

import { sizes, spacer } from '../constants';

import typographyOverrides from './typography';

const modalOverrides = {
  MuiDialogTitle: {
    root: {
      ...typographyOverrides.MuiTypography.h3,
      textAlign: 'left',
      color: dealThemePalette.primary.contrastText,
      backgroundColor: dealThemePalette.secondary.main,
      '& .MuiIconButton-root': {
        color: colors.white,
      },
      padding: `${spacer.spacer1}px 0 0 ${spacer.spacer2}px`,
    },
  },
  MuiDialog: {
    paperWidthSm: {
      maxWidth: sizes.small + spacer.spacer3,
      '& form button': {
        margin: 'auto !important',
      },
    },
    paperWidthMd: {
      maxWidth: 2 * sizes.small + spacer.spacer3,
    },
    paperWidthLg: {
      maxWidth: 3 * sizes.small + spacer.spacer3,
    },
  },
  MuiDialogContent: {
    root: {
      padding: '8px 16px',
      backgroundColor: dealThemePalette.primary.main,
      '&.myModal': {
        padding: '0px',
      },
    },
  },
};

export default modalOverrides;
